import { useContext } from 'react';
import { OutcomeBuilderContext } from '../OutcomeBuilderContext';

export const useOutcomeBuilderContext = () => {
    const outcomeBuilderContext = useContext(OutcomeBuilderContext);

    if (!outcomeBuilderContext) {
        throw new Error('OutcomeBuilderContext not initialized');
    }

    return outcomeBuilderContext;
};
